export function renderRich(raw) {
  const esc = (s) => (s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  const inline = (s) => esc(s)
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/(^|[^*])\*(?!\s)(.+?)\*/g, "$1<em>$2</em>");
  const lines = (raw || "").split(/\r?\n/);
  let html = "", inList = false;
  for (const ln of lines) {
    const t = ln.trim();
    if (/^(- |\* )/.test(t)) { if (!inList) { html += "<ul>"; inList = true; } html += `<li>${inline(t.slice(2))}</li>`; continue; }
    if (inList) { html += "</ul>"; inList = false; }
    if (/^### /.test(t)) html += `<h4>${inline(t.slice(4))}</h4>`;
    else if (/^## /.test(t)) html += `<h3>${inline(t.slice(3))}</h3>`;
    else if (/^# /.test(t)) html += `<h2>${inline(t.slice(2))}</h2>`;
    else if (t === "") continue;
    else html += `<p>${inline(t)}</p>`;
  }
  if (inList) html += "</ul>";
  return html;
}
